export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAFElEQVR4AWOgG/hPJCYMRp00OAEABVEd43gUjQYAAAAASUVORK5CYII="